import PageTask from './PageTask'

export default PageTask
